import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = `${process.env.REACT_APP_PORTAL_APP_BASE_URL}/auth/login`;

export const loginUser = createAsyncThunk(
  'auth/loginUser',
  async ({ email, password }, { rejectWithValue }) => {
    try {
      const response = await axios.post(API_URL, { email, password });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Slice
const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: null,
    token: null,
    isLoading: false,
    isAuthenticated: false,
    error: null,
  },
  reducers: {
    login: (state, { payload }) => {
      const { user, token, rememberMe } = payload;
      state.isLoading = false;
      state.user = user.email || null;
      state.token = token || null;
      state.isAuthenticated = true;
      const storage = rememberMe ? localStorage : sessionStorage;
      storage.setItem("user", JSON.stringify(user.email || {}));
      storage.setItem("token", token || "");
      storage.setItem("profileData", JSON.stringify(user));
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    },
    login2: (state, { payload }) => {
      const { user, token, rememberMe } = payload;
      state.isLoading = false;
      state.user = user.email || null;
      state.token = token || null;
      state.isAuthenticated = true;
      const storage = rememberMe ? localStorage : sessionStorage;
      storage.setItem("user", JSON.stringify(user.email || {}));
      storage.setItem("token", token || "");
      storage.setItem("profileData", JSON.stringify(user));
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      localStorage.removeItem('profileData');
      sessionStorage.removeItem('user');
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('profileData');
    },
  },
  // extraReducers: (builder) => {
  //   builder
  //     .addCase(loginUser.pending, (state) => {
  //       state.isLoading = true;
  //       state.error = null;
  //     })
  //     .addCase(loginUser.fulfilled, (state, action) => {
  //       const { data } = action.payload;
  //       state.isLoading = false;
  //       state.user = data.email || null;
  //       state.token = data.token || null;
  //       state.isAuthenticated = true;
  //       localStorage.setItem("user", JSON.stringify(data.email || {}));
  //       localStorage.setItem("token", data.token || "");
  //       localStorage.setItem("profileData", JSON.stringify(data));
  //     })
  //     .addCase(loginUser.rejected, (state, action) => {
  //       state.isLoading = false;
  //       state.error = action.payload || 'Failed to login.';
  //     });
  // },
});

export const { logout, login, login2 } = authSlice.actions;
export default authSlice.reducer;